import React, { useEffect, useState } from "react";
import { Box, Typography, Grid, Paper } from "@mui/material";
import SalesSummary from "../../common/salarySummery";
import { useLocation, useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { routePath } from "../../constants/routePath";
import { getData2 } from "./dashboardCustomApiHandlers";
import { getdashBoardApi } from "../../utils/utils";
import dayjs from "dayjs";
import { ArrowBackIcon } from "../../common/icon";
import Heading from "../../common/Heading";

const DashboardT = () => {
  const userDetail = useSelector((state) => state.reducer.userDetail);
  const [dashboard, setDashboard] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const [salesData, setSalesData] = useState([]);

  useEffect(() => {
    if (
      location.pathname === routePath.DASHBOARD &&
      Object.keys(userDetail).length !== 0
    ) {
      getData2(getdashBoardApi, setDashboard);
      // console.log("dashbaord=============",dashboard);
      if (userDetail.appMenu !== "Biller") {
        // navigate(routePath.SERVICESLIST);
      }
    }
  }, [location.pathname, userDetail]);
  useEffect(() => {
    let arr = [
      {
        label: "Total Sale",
        today: dashboard?.totalCounterSales?.toFixed(2) ?? 0,
        monthly: dashboard?.currentMonthSale?.toFixed(2),
      },

      {
        label: "Counter Sale",
        today: dashboard?.totalCashSales?.toFixed(2) ?? 0,
        monthly: dashboard?.currentMonthSaleCashOnline?.toFixed(2),
      },

      {
        label: "Credit Sale",
        today: dashboard?.totalCreditSales?.toFixed(2) ?? 0,
        monthly: dashboard?.currentMonthSaleCredit?.toFixed(2),
      },

      {
        label: "Expenses",
        today: dashboard?.todayExpense?.toFixed(2) ?? 0,
        monthly: dashboard?.monthlyExpense?.toFixed(2),
      },

      {
        label: "Number of Bills",
        today: dashboard?.totalNumberOfBillsForDay?.toFixed(2) ?? 0,
        monthly: dashboard?.totalNumberOfBillsForMonth,
      },

      {
        label: "Products Sold",
        today: dashboard?.currentDayProductSold?.toFixed(2) ?? 0,
        monthly: dashboard?.currentMonthProductSold,
      },

      {
        label: "Services Sold",
        today: dashboard?.currentDayServicesSold?.toFixed(2) ?? 0,
        monthly: dashboard?.currentMonthServicesSold,
      },
    ];
    setSalesData(arr);
  }, [dashboard]);

  const data = [
    {
      label: "Unassigned",
      value: dashboard?.todaysUnassignedAppointments,
      color: "#A11819",
    },
    {
      label: "Assigned",
      value: dashboard?.todaysAssignedAppointments,
      color: "#FFBB00",
    },
    {
      label: "Completed",
      value: dashboard?.todaysCompletedAppointments,
      color: "#3AC10D",
    },
    {
      label: "Cancelled",
      value: dashboard?.todaysCancelledAppointments,
      color: "#010093",
    },
  ];

  return (
    <Box
      sx={{
        px: { sm: 4, xs: 2 },
        marginBottom: "20px",
        backgroundColor: "#E3E3FF",
        minHeight: "100vh",
      }}
    >
      <Box
        sx={{
          py: "5px",
        }}
      >
        <Typography
          variant="caption"
          sx={{
            color: "##01008B",
            fontSize: "14px",
            fontWeight: "medium",
            fontFamily: "'Montserrat', sans-serif",
          }}
        >
          Last updated on :{" "}
          <span
            style={{
              color: "#BB4A9B",
            }}
          >
            {" "}
            {/* 16 Apr 02:22:44 PM */}
            {dayjs().format("DD-MM-YYYY h:mm:ss A")}
          </span>
        </Typography>
      </Box>

      <Box sx={{ mb: 2 }}>
        <Heading name="Appointments" />
      </Box>

      {/* <Grid container alignItems="center" spacing={2}>
       
        <Grid item>
          <ArrowBackIcon
            sx={{ cursor: "pointer" }}
            onClick={() => navigate("/home")}
          />
        </Grid>

       
        <Grid item xs>
          <Box
            sx={{
              background:
                "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
              padding: "10px",
              mt: "10px",
              borderRadius: "5px",
              color: "#01008B",
              textAlign: "left",
              marginBottom: "20px",
              fontFamily: "'Montserrat', sans-serif",
              fontSize: "20px",
              fontWeight: 500,
            }}
          >
            <Typography
              sx={{
                typography: { xs: "h6", sm: "h6" },
                fontSize: {
                  xs: "12px",
                  sm: "13px",
                  md: "20px",
                },
              }}
            >
              Appointments
            </Typography>
          </Box>
        </Grid>
      </Grid> */}
      <Grid
        container
        spacing={{ sm: 6, xs: 1 }}
        sx={{
          // px: "30px",
          paddingBottom: "30px",
        }}
      >
        {data.map((item, idx) => (
          <Grid item xs={6} md={3} key={idx}>
            <Paper
              elevation={3}
              sx={{
                backgroundColor: item.color,
                color: "white",
                textAlign: "center",
                py: 2,
                borderRadius: 2,
                fontFamily: "'Montserrat', sans-serif",
              }}
            >
              <Typography
                fontWeight="400"
                sx={{
                  xs: "12px",
                  sm: "13px",
                  md: "20px",
                }}
              >
                {item.label}
              </Typography>
              <Typography
                fontWeight="500"
                fontSize={{
                  xs: "12px",
                  sm: "15px",
                  md: "32px",
                }}
              >
                {item.value}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
      <Box
        sx={{
          background:
            "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
          padding: "10px",
          mt: "10px",
          borderRadius: "5px",
          color: "#01008B", // optional text color
          textAlign: "left",
          marginBottom: "20px",
          fontFamily: "'Montserrat', sans-serif",
          fontSize: "20px",
          fontWeight: 500,
        }}
      >
        <Typography
          variant="h6"
          fontSize={{
            xs: "12px",
            sm: "13px",
            md: "20px",
          }}
        >
          Sales
        </Typography>
      </Box>
      <SalesSummary salesData={salesData ?? []} />
    </Box>
  );
};

export default DashboardT;
